<div class="confirm-telephone" [ngClass]="{'with-min-h' : haveMinHeight}">
  @if (sesion.stepConfirmTelephone==1) {
  <div class="step-telephone">
    <div class="info">
      <h2>Queremos conocerte mejor, completa la siguiente información.</h2>
      <p>Esto nos permitirá mostrarte ofertas más cercanas a tu perfil crediticio.</p>
    </div>
    <form class="form-telephone" autocomplete="off" novalidate #datos="ngForm">
      <div class="form-group">
        <label for="cellphone">Tu número celular:</label>
        <input class="form-control" placeholder="Celular" minlength="10" maxlength="10" type="tel" class="form-control"
          id="celular" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)" required="required" [(ngModel)]="sesion.userPhone"
          #celular="ngModel" name="celular"
          [ngClass]="{'is-valid': celular.valid, 'is-invalid': ( celular.errors?.['required'] && celular.touched ) }">
        @if (errorSendCode) {
        <div class="error">
          <p>No fue posible enviar el código de validación. Verifica el número e inténtalo nuevamente.</p>
        </div>
        }
      </div>
      <div class="ctas">
        @if (!loadSendCode) {
        <button (click)="sendCode()" [attr.disabled]="datos.valid ? null : 'disabled'"
          [ngClass]="{'disabled': !datos.valid }" type="submit" class="btn-mrkt green apply_{{load.title}}"
          id="actualizarOferta">
          Continuar
          <i class="fa fa-angle-right apply_{{load.title}}" aria-hidden="true"></i>
        </button>
        }
        @if (loadSendCode) {
        <button class="btn-mrkt green disabled" disabled="disabled">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
        }
        @if (!loadSendCode) {
        <button (click)="closeModalConfirm()" class="btn-mrkt blue cancelar_{{load.title}}" id="cancelarOferta">
          Cancelar
          <i class="fa fa-angle-right cancelar_{{load.title}}" aria-hidden="true"></i>
        </button>
        }
      </div>
    </form>
  </div>
  }
  @if (sesion.stepConfirmTelephone==2) {
  <div class="step-code">
    <div class="info">
      <h2>Validación de celular.</h2>
      <p>Por favor ingresa el código de seis (6) dígitos que enviamos vía mensaje de texto al celular que
        ingresaste.
        <br />
        <br />Esto facilitará el proceso de aplicación con el Aliado.
      </p>
    </div>
    <form class="form-code" autocomplete="off" novalidate #datosCode="ngForm">
      <div class="form-group code-cel">
        <label for="code">Ingresa código</label>
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-1" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-2" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-3" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-4" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-5" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        <input class="form-control" (input)="nextNumCode($event)" (keyup)="nextNumCode($event,true)" minlength="1"
          maxlength="1" type="tel" class="form-control" id="code-6" pattern="^(?!.*(\d)\1{3,})(^(3)\d*$)"
          required="required">
        @if (errorCode) {
        <div class="error">
          <p>El código ingresado es incorrecto.</p>
        </div>
        }
        <div class="re-code">
          <p><b>{{minutes | number:'2.0'}}:{{seconds | number:'2.0' }}</b> Para poder solicitar un nuevo
            código</p>
          <button (click)="sendCode(true)" [disabled]="isSendCode && sesion.tryValidationCode < 2">- Enviar un
            nuevo código -</button>
        </div>
      </div>
      <div class="ctas">
        @if (!loadSendCode) {
        <button (click)="validateCode()" [attr.disabled]="isValidCode() ? null : 'disabled'"
          [ngClass]="{'disabled': !isValidCode() }" type="submit" class="btn-mrkt green apply_{{load.title}}"
          id="actualizarOferta">
          Continuar
          <i class="fa fa-angle-right apply_{{load.title}}" aria-hidden="true"></i>
        </button>
        }
        @if (loadSendCode) {
        <button class="btn-mrkt green disabled" disabled="disabled">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
        }
        @if (!loadSendCode) {
        <button (click)="nextStep(1)" class="btn-mrkt blue cancelar_{{load.title}}" id="cancelarOferta">
          Cancelar
          <i class="fa fa-angle-right cancelar_{{load.title}}" aria-hidden="true"></i>
        </button>
        }
      </div>
    </form>
  </div>
  }
  @if (sesion.stepConfirmTelephone==3 && offerService.hasSoftFilter) {
  <div class="step-filter">
    <app-soft-filters (closeModalEvent)="closeModalConfirm()" (rejectedFiltersEvent)="resultFilters($event)"
      (updatePhoneEvent)="nextStep(1)"></app-soft-filters>
  </div>
  }
  @if (sesion.stepConfirmTelephone==4 && !sesion.confirmTelephoneConecta) {
  <div class="step-confirm">
    <h2 class="green">¡Buenas noticias, {{sesion.nameSession}}!</h2>
    <p>Tu <b>{{offerService.offerSelected?.card?.productName}}</b> está casi listo para ser aprobado.</p>
    <p class="text-center">Algunas cosas a tener en cuenta para continuar con tu proceso de aplicación:</p>
    <p><b class="numeral">1.</b> Buscacrédito hace un pre-filtro de tu perfil crediticio, sin embargo, la
      <b>aprobación final</b> dependerá de <b>{{offerService.offerSelected?.company?.name}}</b>.
    </p>
    <p><b class="numeral">2.</b> El proceso de aplicación se termina en el <b>sitio web del aliado</b>, nosotros te
      redireccionaremos allí..</p>
    <p><b class="numeral">3.</b> <b> Los tiempos</b> de respuesta varían de acuerdo con las políticas de cada
      entidad..</p>
    @if (sesion.semiValid) {
    <div class="warning">
      <p>¡No fue posible validar su número! Sin embargo, aún puede continuar con la aplicación.</p>
    </div>
    }
    @if (offerService.errorApply) {
    <div class="error">
      <p>En este momento no es posible aplicar a esta oferta. Por favor inténtalo más tarde.
      </p>
    </div>
    }
    @if (loadApplyOffer) {
    <button class="btn-mrkt green disabled" disabled="disabled">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
    }
    @if (offerService.errorApply && !loadApplyOffer) {
    <button (click)="closeModalConfirm()" class="btn-mrkt green">
      Ver mas ofertas
      <i class="fa fa-angle-right apply_{{load.title}}" aria-hidden="true"></i>
    </button>
    }
    @if (!offerService.errorApply && !loadApplyOffer) {
    <button (click)="finalStep()" class="btn-mrkt green">
      Continuar con la aplicación
      <i class="fa fa-angle-right apply_{{load.title}}" aria-hidden="true"></i>
    </button>
    }
    @if (!offerService.errorApply && !loadApplyOffer) {
    <button (click)="nextStep(1)" class="btn-mrkt secondary">
      Actualizar mi número de celular
    </button>
    }
  </div>
  }
</div>